export default __webpack_public_path__ + "f4827b57bd1dbfc669207fba4f621089.png";